import {Map} from "@dropDesk/domain/entities/ticket/ticket_maps";

export const listableForClientsMap: Map<string>[] = [
    {value: 'true', label: "Listável para o cliente"},
    {value: 'false', label: "Listável internamente"},
];
